// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"634":"65eee80e","710":"65eee80e"}[chunkId] + ".chunk.css";
};